import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'service.home',
    defaultMessage: 'Home',
  },
  transactionsTitle: {
    id: 'transactions.title',
    defaultMessage: 'Transaction Log',
  },
  detailTitle: {
    id: 'service.detail.title',
    defaultMessage: 'Service Detail',
  },
  createTitle: {
    id: 'service.create',
    defaultMessage: 'Add New Service',
  },
  breadcrumbAddService: {
    id: 'service.breadcrumb.create',
    defaultMessage: 'Add New Service',
  },
  breadcrumbServiceDetail: {
    id: 'service.breadcrumb.detail',
    defaultMessage: 'Service Detail',
  },
  refundStatus: {
    init: {
      id: 'transactions.refundStatus.init',
      defaultMessage: 'INIT',
    },
    progress: {
      id: 'transactions.refundStatus.progress',
      defaultMessage: 'PROGRESS',
    },
    manualRefund: {
      id: 'transactions.refundStatus.manualRefund',
      defaultMessage: 'MANUAL_REFUND',
    },
    refunded: {
      id: 'transactions.refundStatus.refunded',
      defaultMessage: 'REFUNDED',
    },
  },
  orderStatus: {
    init: {
      id: 'transactions.orderStatus.init',
      defaultMessage: 'Order Made',
    },
    inProgress: {
      id: 'transactions.orderStatus.inProgress',
      defaultMessage: 'Order Processed',
    },
    completed: {
      id: 'transactions.orderStatus.completed',
      defaultMessage: 'Order Successful',
    },
    failed: {
      id: 'transactions.orderStatus.failed',
      defaultMessage: 'Order Failed',
    },
    expired: {
      id: 'transactions.orderStatus.expired',
      defaultMessage: 'Pesanan Kadaluarsa',
    },
    refunded: {
      id: 'transactions.orderStatus.refunded',
      defaultMessage: 'Order Refunded',
    },
    status: {
      id: 'transactions.orderStatus.status',
      defaultMessage: 'Waiting for Verification',
    },
  },
  table: {
    labelNo: {
      id: 'transactions.table.column.no',
      defaultMessage: 'No',
    },
    danaOrderType: {
      id: 'transactions.table.column.danaOrderType',
      defaultMessage: 'dana_order_type',
    },
    danaFinishTime: {
      id: 'transactions.table.column.danaFinishTime',
      defaultMessage: 'dana_finish_time',
    },
    aggregatorFinishTime: {
      id: 'transactions.table.column.aggregatorFinishTime',
      defaultMessage: 'aggregator_finish_time',
    },
    transactionId: {
      id: 'transactions.table.column.id',
      defaultMessage: 'public_id',
    },
    danaOrderId: {
      id: 'transactions.table.column.danaOrderId',
      defaultMessage: 'dana_order_id',
    },
    partnerTransactionId: {
      id: 'transactions.table.column.partnerTransactionId',
      defaultMessage: 'aggregator_transaction_id',
    },
    customerId: {
      id: 'transactions.table.column.customerId',
      defaultMessage: 'customer_id',
    },
    orderStatus: {
      id: 'transactions.table.column.orderStatus',
      defaultMessage: 'order_status',
    },
    transactionDateTime: {
      id: 'transactions.table.column.transactionDateTime',
      defaultMessage: 'Transaction Date and Time',
    },
    serviceName: {
      id: 'transactions.table.column.serviceName',
      defaultMessage: 'service_name',
    },
    serviceCategory: {
      id: 'transactions.table.column.serviceCategory',
      defaultMessage: 'service_category',
    },
    billerName: {
      id: 'transactions.table.column.billerName',
      defaultMessage: 'biller_name',
    },
    aggregatorId: {
      id: 'transactions.table.column.aggregatorId',
      defaultMessage: 'aggregator_id',
    },
    aggregatorName: {
      id: 'transactions.table.column.aggregatorName',
      defaultMessage: 'aggregator_name',
    },
    danaPublicId: {
      id: 'transactions.table.column.danaPublicId',
      defaultMessage: 'dana_public_id',
    },
    transactionAmount: {
      id: 'transactions.table.column.transactionAmount',
      defaultMessage: 'transaction_amount',
    },
    transactionFee: {
      id: 'transactions.table.column.transactionFee',
      defaultMessage: 'transaction_fee',
    },
    aggregatorFee: {
      id: 'transactions.table.column.aggregatorFee',
      defaultMessage: 'aggregator_fee',
    },
    aggregatorServiceTax: {
      id: 'transactions.table.column.aggregatorServiceTax',
      defaultMessage: 'aggregator_service_tax',
    },
    partnerFee: {
      id: 'transactions.table.column.partnerFee',
      defaultMessage: 'Partner Fee',
    },
    totalAmountDana: {
      id: 'transactions.table.column.totalAmountDana',
      defaultMessage: 'total_amount_dana',
    },
    totalAmountAggregator: {
      id: 'transactions.table.column.totalAmountAggregator',
      defaultMessage: 'total_amount_aggregator',
    },
    action: {
      id: 'transactions.table.column.action',
      defaultMessage: 'Action',
    },
    createdAt: {
      id: 'transactions.table.column.createdAt',
      defaultMessage: 'created_at',
    },
    updatedAt: {
      id: 'transactions.table.column.updatedAt',
      defaultMessage: 'updated_at',
    },
  },
  filter: {
    prefix: {
      serviceName: {
        id: 'transactions.filter.prefix.serviceName',
        defaultMessage: 'Service Name is',
      },
      serviceCategory: {
        id: 'transactions.filter.prefix.serviceCategory',
        defaultMessage: 'Service Category is',
      },
      billName: {
        id: 'transactions.filter.prefix.billName',
        defaultMessage: 'Bill Name is',
      },
      aggregatorName: {
        id: 'transactions.filter.prefix.aggregatorName',
        defaultMessage: 'Aggregator Name is',
      },
      transactionId: {
        id: 'transactions.filter.prefix.transactionId',
        defaultMessage: 'Transaction ID is',
      },
      acquisitionId: {
        id: 'transactions.filter.prefix.acquisitionId',
        defaultMessage: 'Acquisition ID is',
      },
      transactionDate: {
        id: 'transactions.filter.prefix.transactionDate',
        defaultMessage: 'Transaction Date is',
      },
      customerNumber: {
        id: 'transactions.filter.prefix.customerNumber',
        defaultMessage: 'Customer Number is',
      },
      orderStatus: {
        id: 'transactions.filter.prefix.orderStatus',
        defaultMessage: 'Order Status is',
      },
      refundStatus: {
        id: 'transactions.filter.prefix.refundStatus',
        defaultMessage: 'Refund Status is',
      },
    },
    label: {
      serviceName: {
        id: 'transactions.filter.label.serviceName',
        defaultMessage: 'Service Name',
      },
      serviceCategory: {
        id: 'transactions.filter.label.serviceCategory',
        defaultMessage: 'Service Category',
      },
      billName: {
        id: 'transactions.filter.label.billName',
        defaultMessage: 'Bill Name',
      },
      aggregatorName: {
        id: 'transactions.filter.label.aggregatorName',
        defaultMessage: 'Aggregator Name',
      },
      transactionId: {
        id: 'transactions.filter.label.transactionId',
        defaultMessage: 'Transaction ID',
      },
      acquisitionId: {
        id: 'transactions.filter.label.acquisitionId',
        defaultMessage: 'Acquisition ID',
      },
      transactionDate: {
        id: 'transactions.filter.label.transactionDate',
        defaultMessage: 'Transaction Date',
      },
      customerNumber: {
        id: 'transactions.filter.label.customerNumber',
        defaultMessage: 'Customer Number',
      },
      orderStatus: {
        id: 'transactions.filter.label.orderStatus',
        defaultMessage: 'Order Status',
      },
      refundStatus: {
        id: 'transactions.filter.label.refundStatus',
        defaultMessage: 'Refund Status',
      },
    },
    refundStatus: {
      manualRefund: {
        id: 'transactions.filter.refundStatus.manualRefund',
        defaultMessage: 'Manual Refund',
      },
      noRefund: {
        id: 'transactions.filter.refundStatus.noRefund',
        defaultMessage: 'No Refund',
      },
    },
    orderStatus: {
      init: {
        id: 'transactions.filter.orderStatus.init',
        defaultMessage: 'INIT',
      },
      inProgress: {
        id: 'transactions.filter.orderStatus.inProgress',
        defaultMessage: 'IN PROGRESS',
      },
      failed: {
        id: 'transactions.filter.orderStatus.failed',
        defaultMessage: 'FAILED',
      },
      refunded: {
        id: 'transactions.filter.orderStatus.refunded',
        defaultMessage: 'REFUNDED',
      },
      expired: {
        id: 'transactions.filter.orderStatus.expired',
        defaultMessage: 'EXPIRED',
      },
      completed: {
        id: 'transactions.filter.orderStatus.completed',
        defaultMessage: 'COMPLETED',
      },
      warning: {
        id: 'transactions.filter.orderStatus.warning',
        defaultMessage: 'WARNING',
      },
      urgent: {
        id: 'transactions.filter.orderStatus.urgent',
        defaultMessage: 'URGENT',
      },
      suspect: {
        id: 'transactions.filter.orderStatus.suspect',
        defaultMessage: 'SUSPECT',
      },
      danger: {
        id: 'transactions.filter.orderStatus.danger',
        defaultMessage: 'DANGER',
      },
      confirmed: {
        id: 'transactions.filter.orderStatus.confirmed',
        defaultMessage: 'CONFIRMED',
      },
      submitted: {
        id: 'transactions.filter.orderStatus.submitted',
        defaultMessage: 'SUBMITTED',
      },
      declined: {
        id: 'transactions.filter.orderStatus.declined',
        defaultMessage: 'DECLINED',
      },
      reopened: {
        id: 'transactions.filter.orderStatus.reopened',
        defaultMessage: 'REOPENED',
      },
    },
    errorMessage: {
      shortenedTrxId: {
        id: 'transactions.filter.errorMessage.shortenedTrxId',
        defaultMessage: 'Enter last 4 digit Transaction Id',
      },
    },
  },
  invoice: {
    label: {
      totalPayment: {
        id: 'transactions.invoice.label.totalPayment',
        defaultMessage: 'Total Payment',
      },
      paymentAmount: {
        id: 'transactions.invoice.label.paymentAmount',
        defaultMessage: 'Price',
      },
      adminFee: {
        id: 'transactions.invoice.label.adminFee',
        defaultMessage: 'Admin Fee',
      },
      informationDetail: {
        id: 'transactions.invoice.label.informationDetail',
        defaultMessage: 'Information Detail',
      },
      serviceName: {
        id: 'transactions.invoice.label.serviceName',
        defaultMessage: 'Service Name',
      },
      bankProvider: {
        id: 'transactions.invoice.label.bankProvider',
        defaultMessage: 'Provider Name',
      },
      creditCardName: {
        id: 'transactions.invoice.label.creditCardName',
        defaultMessage: 'Customer Number',
      },
      nameOnCreditCard: {
        id: 'transactions.invoice.label.nameOnCreditCard',
        defaultMessage: 'Customer Name',
      },
      invoiceNumber: {
        id: 'transactions.invoice.label.invoiceNumber',
        defaultMessage: 'Invoice Number',
      },
    },
  },
});
